import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsFindBy } from 'services/WService.js';

export default WithApp(function ModalReason(props) {
  const reason = props.model;

  const [dataChanging, setDataChanging] = useState({});


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }


  return (
    <>
      <Modal
        title={`Nuevo motivo de transferencia`}
        model={{ open: reason.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={'logi/reason-transfer'}
      >
        <TextField
            label="Código"
            fullWidth
            type="text"
            name="code"
            margin="normal"
            value={dataChanging.code || ''}
            onChange={(e) => handleChange('code', e.target.value)}
            required
        />
        <TextField
            label="Motivo"
            fullWidth
            type="text"
            name="reason"
            margin="normal"
            value={dataChanging.reason || ''}
            onChange={(e) => handleChange('reason', e.target.value)}
            required
        />
      </Modal>
    </>
  );
});
